import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

type ShortlistRow = Readonly<{
  institution_id?: string;
  name?: string;
  tier: string;
  in_my_colleges?: boolean;
}>;

export const useAgentContext = (schools: readonly ShortlistRow[]) => {
  useRegisterAgentContext(
    schools.length
      ? {
          kind: 'list',
          description:
            'The college shortlist on screen, by tier, with an Add to my college list button per college and a Save all to my college list button. in_my_colleges says whether the student has already saved it to their college list.',
          data: schools,
        }
      : null,
  );
};
